// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"595792b0","334":"7111a7ca","482":"84961f34","717":"595792b0"}[chunkId] + ".chunk.css";
};